import React from 'react';
import { Box, Typography, useTheme, Select, MenuItem, FormControl, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from 'react-i18next';

/**
 * Header component for page titles and tabs
 * 
 * @param {Object} props - Component props
 * @param {string} props.title - Page title
 * @param {Array} props.tabs - Array of tab objects with label properties
 * @param {number} props.activeTab - Index of the active tab
 * @param {Function} props.onTabChange - Function to handle tab changes
 * @param {boolean} props.showTabs - Whether to show tabs (default: true)
 */
const Header = ({ title, showMenuButton = false, onMenuClick = () => {} }) => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  const handleLanguageChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        padding: { xs: `${theme.spacing(1.5)} ${theme.spacing(2)}`, md: `${theme.spacing(2)} ${theme.spacing(3)}` },
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, flex: 1 }}>
        {showMenuButton && (
          <IconButton
            onClick={onMenuClick}
            edge="start"
            aria-label={t('openMenu')}
            sx={{ color: 'inherit', mr: 0.5 }}
          >
            <MenuIcon />
          </IconButton>
        )}
        <Typography
          variant="h5"
          component="div"
          noWrap
          sx={{
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: { xs: '1.1rem', sm: '1.25rem', md: theme.typography.h5.fontSize },
            paddingLeft: theme.spacing(1),
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 0,
          }}
        >
          {title}
        </Typography>
      </Box>

      <FormControl size="small" sx={{ minWidth: { xs: 92, sm: 120 }, flexShrink: 0 }}>
        <Select
          value={i18n.language}
          onChange={handleLanguageChange}
          sx={{
            color: 'white',
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(255, 255, 255, 0.23)',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(255, 255, 255, 0.4)',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'white',
            },
            '.MuiSelect-icon': {
              color: 'white',
            },
          }}
        >
          <MenuItem value="en">English</MenuItem>
          <MenuItem value="es">Español</MenuItem>
          <MenuItem value="it">Italiano</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default Header;